var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('form-ficha-saude',{attrs:{"alunoId":_vm.$route.params.aluno_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }